// /accounts/$accountSlug/tenants/$tenantSlug — layout. Wraps every
// child route (overview, sites, ha-instances, secrets, ...) with the
// shared tenant header + tab strip via TenantLayout, then yields to
// the child via <Outlet /> inside that component.

import { createFileRoute } from "@tanstack/react-router";

import { TenantLayout } from "../features/tenants/TenantLayout";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug",
)({
  component: TenantLayoutRoute,
});

function TenantLayoutRoute() {
  const { accountSlug, tenantSlug } = Route.useParams();
  return <TenantLayout accountSlug={accountSlug} tenantSlug={tenantSlug} />;
}
